import { TENANT_URL_TEMPLATE } from "@/config";

export const fillUrlTemplate = (slug: string) => {
  return TENANT_URL_TEMPLATE.replace(/{(\w+)}/g, slug);
};

export const doRedirectToTenant = (tenantSlug: string): void => {
  window.location.href = fillUrlTemplate(tenantSlug);
};
